import { Injectable } from '@angular/core';
import { DictionaryService } from '@app/core/services/dictionary.service';
import { TimetablePeriod } from '@app/pcs/models';
import * as R from 'ramda';

@Injectable()
export class TimetablePeriodsService {

  constructor(private dictionaryService: DictionaryService) {
  }

  getById(id: number): TimetablePeriod {
    return R.find(R.propEq('id', id))(this.dictionaryService.getTimetablePeriods()) as TimetablePeriod;
  }

  getNextTtpId() {
    const ttpIds = R.map(R.prop('id'), this.dictionaryService.getTimetablePeriods()) as number[];
    const lastTtpId = R.reduce(R.max, 0, ttpIds) as number;
    return R.inc(lastTtpId);
  }

  updateTimetablePeriod(timetablePeriod: TimetablePeriod) {
    const timetablePeriods = this.dictionaryService.getTimetablePeriods() as TimetablePeriod[];
    const index = R.findIndex(R.propEq('id', timetablePeriod.id))(timetablePeriods);
    const newTimetablePeriods = R.equals(index, -1)
      ? R.prepend(timetablePeriod, timetablePeriods)
      : R.map(ttp => R.propEq('id', timetablePeriod.id, ttp) ? timetablePeriod : ttp, timetablePeriods);
    this.dictionaryService.setTimetablePeriods(newTimetablePeriods);
  }
}
